export const SnackBarActions = Object.freeze({
    DISPLAY_SUCCESS: 'snackbar/DISPLAY_SUCCESS',

    displayMessage: (message) => dispatch => {
        return dispatch({type: SnackBarActions.DISPLAY_SUCCESS, payload: message})
    }
});


// WEBPACK FOOTER //
// ./src/actions/snackbar.actions.js